import { render, staticRenderFns } from "./User.Menu.Provider.vue?vue&type=template&id=05c5f035&scoped=true&"
import script from "./User.Menu.Provider.vue?vue&type=script&lang=js&"
export * from "./User.Menu.Provider.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.Provider.vue?vue&type=style&index=0&id=05c5f035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5f035",
  null
  
)

export default component.exports